import { render, staticRenderFns } from "./DialogNnter.vue?vue&type=template&id=f2834060&scoped=true&"
import script from "./DialogNnter.vue?vue&type=script&lang=js&"
export * from "./DialogNnter.vue?vue&type=script&lang=js&"
import style0 from "./DialogNnter.vue?vue&type=style&index=0&id=f2834060&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2834060",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2834060')) {
      api.createRecord('f2834060', component.options)
    } else {
      api.reload('f2834060', component.options)
    }
    module.hot.accept("./DialogNnter.vue?vue&type=template&id=f2834060&scoped=true&", function () {
      api.rerender('f2834060', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Activity/components/DialogNnter.vue"
export default component.exports